import { Cushion, Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from '../../lib/i18n';
import PreviewFixture from './preview-fixture';

const CompetitionRoundup = ({ fixtures, competitionName }) => (
  <Rectangle
    fill="white"
    style={{ border: '1px solid #d9d9d9', overflow: 'hidden' }}
    responsive={[{ minWidth: 'fullHeader', props: { radius: 'rounded' } }]}
  >
    <Rectangle fill="#fafafa">
      <Cushion all="small">
        <Typography size={16} weight="bold" color="black" align="center" component="h3">
          <Trans i18nKey="teams:competition_roundup_title" values={{ competitionName }}>
            {`${competitionName} Fixtures`}
          </Trans>
        </Typography>
      </Cushion>
    </Rectangle>
    {fixtures.map((fixture, i) => (
      <PreviewFixture fixture={fixture} isLast={i === fixture.length} />
    ))}
  </Rectangle>
);

CompetitionRoundup.propTypes = {
  competitionName: PropTypes.string.isRequired,
  fixtures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ).isRequired,
};

export default CompetitionRoundup;
